import { createContext, FC, PropsWithChildren, useContext } from 'react';
import { Firm } from '../generated/graphql';
import { getVisibleScorecardElementSymbols } from './elementCustomization';
import { SCORECARD_ELEMENT_SYMBOLS } from './constants';
import { ScorecardElementSymbol } from './util';

type ScorecardElementCustomizationContextValue = {
  firm?: Pick<Firm, 'elementCustomizationBetaEnabled' | 'elementCustomizations'> | null;
  isFirmLoading?: boolean;
};

const ScorecardElementCustomizationContext = createContext<ScorecardElementCustomizationContextValue>({
  firm: null,
  isFirmLoading: false,
});

export const ScorecardElementCustomizationProvider: FC<
  PropsWithChildren<ScorecardElementCustomizationContextValue>
> = ({ children, firm = null, isFirmLoading = false }) => {
  return (
    <ScorecardElementCustomizationContext.Provider value={{ firm, isFirmLoading }}>
      {children}
    </ScorecardElementCustomizationContext.Provider>
  );
};

export function useScorecardElementCustomization() {
  return useContext(ScorecardElementCustomizationContext);
}

export function useVisibleScorecardElements(symbols: ScorecardElementSymbol[] = SCORECARD_ELEMENT_SYMBOLS) {
  const { firm, isFirmLoading } = useScorecardElementCustomization();

  if (isFirmLoading && !firm) return [];

  if (firm?.elementCustomizationBetaEnabled !== true) return symbols;

  return getVisibleScorecardElementSymbols({
    firm,
    symbols,
  });
}
